import { __extends, __rest, __assign, __makeTemplateObject } from 'tslib';
import React, { Component, forwardRef } from 'react';
import { styled } from 'styled-components';
import classnames from 'classnames';
import '../../../reset/HtmlA/HtmlA.js';
import { HtmlButton } from '../../../reset/HtmlButton/HtmlButton.js';
import { HtmlDiv } from '../../../reset/HtmlDiv/HtmlDiv.js';
import '../../../reset/HtmlFieldSet/HtmlFieldSet.js';
import '../../../reset/HtmlH/HtmlH.js';
import '../../../reset/HtmlInput/HtmlInput.js';
import '../../../reset/HtmlLabel/HtmlLabel.js';
import '../../../reset/HtmlLegend/HtmlLegend.js';
import '../../../reset/HtmlLi/HtmlLi.js';
import '../../../reset/HtmlNav/HtmlNav.js';
import '../../../reset/HtmlOl/HtmlOl.js';
import { HtmlSpan } from '../../../reset/HtmlSpan/HtmlSpan.js';
import '../../../reset/HtmlTextarea/HtmlTextarea.js';
import '../../../reset/HtmlUl/HtmlUl.js';
import '../../../reset/HtmlTable/HtmlTable.js';
import '../../../reset/HtmlTable/HtmlTableCaption.js';
import '../../../reset/HtmlTable/HtmlTableHeader.js';
import '../../../reset/HtmlTable/HtmlTableRow.js';
import '../../../reset/HtmlTable/HtmlTableBody.js';
import '../../../reset/HtmlTable/HtmlTableHeaderCell.js';
import '../../../reset/HtmlTable/HtmlTableCell.js';
import { SuomifiThemeConsumer } from '../../theme/SuomifiThemeProvider/SuomifiThemeProvider.js';
import '../../theme/SuomifiTheme/SuomifiTheme.js';
import '../../theme/SpacingProvider/SpacingProvider.js';
import { ExpanderConsumer } from '../Expander/Expander.js';
import { expanderTitleButtonBaseStyles } from './ExpanderTitleButton.baseStyles.js';
import { IconChevronDown } from 'suomifi-icons';

var baseClassName = 'fi-expander_title-button';
var titleOpenClassName = "".concat(baseClassName, "--open");
var titleButtonClassName = "".concat(baseClassName, "_button");
var iconClassName = "".concat(baseClassName, "-icon");
var iconOpenClassName = "".concat(iconClassName, "--open");
var BaseExpanderTitleButton = function (_super) {
  __extends(BaseExpanderTitleButton, _super);
  function BaseExpanderTitleButton() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  BaseExpanderTitleButton.prototype.render = function () {
    var _a, _b;
    var _c = this.props,
      asHeading = _c.asHeading,
      children = _c.children,
      className = _c.className;
      _c.theme;
      var toggleButtonProps = _c.toggleButtonProps,
      consumer = _c.consumer,
      forwardedRef = _c.forwardedRef,
      passProps = __rest(_c, ["asHeading", "children", "className", "theme", "toggleButtonProps", "consumer", "forwardedRef"]);
    return /*#__PURE__*/React.createElement(HtmlDiv, __assign({}, passProps, {
      className: classnames(className, baseClassName, (_a = {}, _a[titleOpenClassName] = !!consumer.open, _a))
    }), /*#__PURE__*/React.createElement(HtmlSpan, __assign({}, !!asHeading ? {
      as: asHeading
    } : {}), /*#__PURE__*/React.createElement(HtmlButton, __assign({
      forwardedRef: forwardedRef
    }, toggleButtonProps, {
      onClick: consumer.onToggleExpander,
      "aria-expanded": !!consumer.open,
      className: titleButtonClassName,
      "aria-controls": consumer.contentId
    }), /*#__PURE__*/React.createElement(HtmlSpan, {
      id: consumer.titleId
    }, children), /*#__PURE__*/React.createElement(IconChevronDown, {
      className: classnames(iconClassName, (_b = {}, _b[iconOpenClassName] = consumer.open, _b))
    }))));
  };
  return BaseExpanderTitleButton;
}(Component);
var StyledExpanderTitle = styled(BaseExpanderTitleButton).withConfig({
  componentId: "sc-1ulzrr5-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return expanderTitleButtonBaseStyles(theme);
});
var ExpanderTitleButton = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SuomifiThemeConsumer, null, function (_a) {
    var suomifiTheme = _a.suomifiTheme;
    return /*#__PURE__*/React.createElement(ExpanderConsumer, null, function (consumer) {
      return /*#__PURE__*/React.createElement(StyledExpanderTitle, __assign({
        theme: suomifiTheme,
        consumer: consumer,
        forwardedRef: ref
      }, props));
    });
  });
});
ExpanderTitleButton.displayName = 'ExpanderTitleButton';
var templateObject_1;

export { ExpanderTitleButton };
//# sourceMappingURL=ExpanderTitleButton.js.map
